/**
 * TierSwitcher Component
 *
 * Two-tab switcher for Drama+ and DramaX tiers
 * Conditionally renders DramaX tab based on feature flag
 */
import { View, Text, Pressable } from "react-native";
import { useTranslation } from "@dramadetector/shared";

type Tier = 'drama_plus' | 'dramax';

interface TierSwitcherProps {
  selectedTier: Tier;
  onTierChange: (tier: Tier) => void;
  showDramaxPlans: boolean;
}

export function TierSwitcher({ selectedTier, onTierChange, showDramaxPlans }: TierSwitcherProps) {
  const { t } = useTranslation('subscription');

  return (
    <View className="flex-row border-b border-gray-200 px-4" testID="subscription-header">
      <Pressable
        onPress={() => onTierChange('drama_plus')}
        className={`flex-1 pb-3 border-b-2 ${
          selectedTier === 'drama_plus' ? 'border-purple-600' : 'border-transparent'
        }`}
      >
        <Text className={`text-center text-lg font-bold ${
          selectedTier === 'drama_plus' ? 'text-purple-600' : 'text-gray-400'
        }`}>
          {t('tiers.drama_plus')}
        </Text>
      </Pressable>

      {showDramaxPlans && (
        <Pressable
          onPress={() => onTierChange('dramax')}
          className={`flex-1 pb-3 border-b-2 ${
            selectedTier === 'dramax' ? 'border-purple-600' : 'border-transparent'
          }`}
        >
          <Text className={`text-center text-lg font-bold ${
            selectedTier === 'dramax' ? 'text-purple-600' : 'text-gray-400'
          }`}>
            {t('tiers.dramax')}
          </Text>
        </Pressable>
      )}
    </View>
  );
}
